import { useState } from "react";
import { useTranslation } from "react-i18next";
import { cld } from "../../utils/cld";

const Img2 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1757965879/2_mjck2l.jpg"

const Faq = () => {
  const { t } = useTranslation();
  const [activeFaq, setActiveFaq] = useState();

  const FAQ = [
    { id: 1, qty: t('faq.q1'), ans: t('faq.a1') },
    { id: 2, qty: t('faq.q2'), ans: t('faq.a2') },
    { id: 3, qty: t('faq.q3'), ans: t('faq.a3') },
    { id: 4, qty: t('faq.q4'), ans: t('faq.a4') },
  ];

  return (
    <>
      <section
        className="faq-area fix"
        style={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="faq-img text-right">
                <img src={cld(Img2, { w: 900 })} alt="Salon lepote Vision Beauty Niš" className="img" width="900" height="1350" loading="lazy" decoding="async" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="section-title mb-50">
                <h2>{t('faq.heading')}</h2>
              </div>
              <div className="faq-wrap">
                <div className="accordion" id="accordionExample">
                  {FAQ.map((item) => (
                    <div className="card" key={item.id}>
                      <div className="card-header" id="headingThree">
                        <h2 className="mb-0" id={`faq-title-${item.id}`}>
                          <button
                            className={`faq-btn ${item.id === activeFaq ? "" : "collapsed"}`}
                            onClick={() => setActiveFaq(item.id)}
                            type="button"
                            aria-labelledby={`faq-title-${item.id}`}
                          >
                            {item.qty}
                            {item.id === activeFaq ? (
                              <i className="fa fa-chevron-down"></i>
                            ) : (
                              <i className="fa fa-chevron-left"></i>
                            )}
                          </button>
                        </h2>
                      </div>
                      {item.id === activeFaq && (
                        <div id="collapseThree" className="collapse show" aria-labelledby="headingThree">
                          <div className={`card-body ${item.id === activeFaq ? "collapsed" : ""}`}>
                            {item.ans}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq;
